import PropTypes from "prop-types";
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import { defaultMessages } from "../../../libs/i18n/default";
import LoadingSpinner from "../LoadingSpinner";

const FirebaseEmailVerificationSend = ({
  intl: { formatMessage },
  setUpdating,
  sendGenerateTokenRequest,
  timer,
  error,
  notice,
  resendInFlight,
  resendButtonRef: resendButtonRefProp,
  clearMessages,
  loading,
  loadingText
}) => {
  const authenticatedUser = useSelector(state => state.authenticatedUser);
  const fallbackResendButtonRef = useRef();
  const resendButtonRef = resendButtonRefProp || fallbackResendButtonRef;
  const clickHereText = formatMessage(defaultMessages.clientCommonClickHere);

  const updateIncorrectEmail = () => {
    clearMessages();
    setUpdating(true);
  };

  return (
    <>
      {loading && <LoadingSpinner label={loadingText} />}
      <div className="text-center verification--container" style={{ display: loading ? "none" : "block" }}>
        {error && (
          <div className="alert alert-danger">
            {error}
          </div>
        )}
        {notice && (
          <div className="alert alert-success">
            {notice}
          </div>
        )}
        <div className="verification--icon">
          <i className="fa fa-envelope" aria-hidden="true"></i>
        </div>
        <h1 className="verification--header">{formatMessage(defaultMessages.clientFirebaseEmailVerificationHeader)}</h1>
        <p>
          <FormattedMessage
            {...defaultMessages.clientFirebaseEmailVerificationInstructions}
            values={{ email: <strong>{authenticatedUser.email}</strong> }}
          />
        </p>
        <hr className="verification--spacer"/>
        <p>
          <FormattedMessage
            {...defaultMessages.clientFirebaseEmailVerificationIncorrectEmail}
            values={{ link: <span id="incorrectEmail" onClick={updateIncorrectEmail}>{clickHereText}</span> }}
          />
        </p>
        <p>
          <FormattedMessage
            {...defaultMessages.clientFirebaseEmailVerificationResend}
            values={{
              link: (
                <span
                  id="resendVerification"
                  className={timer > 0 || resendInFlight ? "disabled" : ""}
                  onClick={() => {
                    clearMessages();
                    sendGenerateTokenRequest({ showErrors: true, markAttempt: true });
                  }}
                  ref={resendButtonRef}
                >
                  {resendInFlight ? (
                    <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
                  ) : (
                    <span className="resend-link">{clickHereText}</span>
                  )}
                </span>
              )
            }}
          />
        </p>
        {timer > 0 && (
          <small>
            <FormattedMessage
              {...defaultMessages.clientFirebaseEmailVerificationVerifyWait}
              values={{ timer }}
            />
          </small>
        )}
      </div>
    </>
  );
};

FirebaseEmailVerificationSend.propTypes = {
  page: PropTypes.string,
  intl: PropTypes.object,
  content: PropTypes.object,
  resendInFlight: PropTypes.bool,
  error: PropTypes.string,
  notice: PropTypes.string,
  timer: PropTypes.number,
  loading: PropTypes.bool,
  loadingText: PropTypes.string,
  setUpdating: PropTypes.func,
  sendGenerateTokenRequest: PropTypes.func,
  resendButtonRef: PropTypes.object,
  clearMessages: PropTypes.func
};

export default FirebaseEmailVerificationSend;
